import { Injectable } from '@angular/core';
import { Api } from '../api/api'

@Injectable()
export class Master {
  list: any;
  lang:any={};

  constructor(public api:Api) { 

  }

  company(params?: any) {
    return this.api.get('index.php/project/master/company', params);
  }

  department(params?: any) {
    return this.api.get('index.php/project/master/department', params);
  }

  sbu(params?: any) {
    return this.api.get('index.php/project/master/sbu', params);
  }

  branch(params?: any) {
    return this.api.get('index.php/project/master/branch', params);
  }

  rate(params?: any) {
    return this.api.get('index.php/project/master/rate', params);
  }

  stage(params?: any) {
    return this.api.get('index.php/project/master/stage', params);
  }

  state(params?: any) {
    return this.api.get('index.php/project/master/state', params);
  }

  getAbout(params?: any) {
    return this.api.get('index.php/project/master/about', params);
  }

  getDisclaimer(params?: any) {
    return this.api.get('index.php/project/master/disclaimer', params);
  }

  language(params?: any) {
    return this.api.get('index.php/project/master/language', params);
  }

  status(params?: any){
    return this.api.get('index.php/project/dashboard/status', params);
  }

}


// WEBPACK FOOTER //
// ./src/providers/project_providers/master/master.ts